import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import NoAccess from '../Common/NoAccess';
import Internal from './Internal';
import AAUS from './AAUS';
import AAUSDetails from './AAUSDetails';
import Expirations from './Expirations';
import Feedings from './Feedings';
import CommProblems from './CommProblems';
import Attendance from './Attendance';

export const Reports = () => {
    const local = useSelector((state) => state.org.remember);
    const permissions = useSelector((state) => state[local ? 'localUser' : 'user'].permissions).split(',');
    const modules = useSelector((state) => state.org.modules);

    return (
        <>
            <Routes>
                <Route element={<ProtectedRoute isAllowed={permissions.indexOf('Report') >= 0} />}>
                    <Route index element={<Internal />} />
                    <Route path="internal" element={<Internal />} />
                    <Route path="aaus" element={<AAUS />} />
                    <Route path="aaus/:year/:type" element={<AAUSDetails />} />
                    <Route path="expirations" element={<Expirations />} />
                    <Route element={<ProtectedRoute isAllowed={modules.indexOf('Schedule') >= 0} />}>
                        <Route path="attendance" element={<Attendance />} />
                    </Route>
                </Route>
                <Route element={<ProtectedRoute isAllowed={modules.indexOf('Feedings') >= 0} />}>
                    <Route path="feedings" element={<Feedings />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={modules.indexOf('Dive incidents') >= 0} />}>
                    <Route path="comm-problems" element={<CommProblems />} />
                </Route>
                <Route path="*" element={<div className="error-404">There's nothing here: 404!</div>} />
            </Routes>
        </>
    );
};

export default Reports;

const ProtectedRoute = ({ isAllowed, children }) => {
    if (!isAllowed) {
      return <NoAccess />;
    } else 
      return <>
        {children ? children : <Outlet />}
      </>;
};